module.exports = __webpack_public_path__ + "6ab74027f0b68d2a008ee74911fdf02d.jpg";